import React, { useState, useEffect } from "react";
import { formatDateTime } from "../utils/formatDate";
import { useLocation } from "react-router-dom";
import { Image, Modal, Button, Form } from "react-bootstrap";
import { RiInformationLine } from "react-icons/ri";
import { HiOutlinePaperAirplane } from "react-icons/hi";
import { FiGlobe } from "react-icons/fi";
import Submission from "./Submission";
import ScoreRubric from "./ScoreRubric";
import PowerUp from "./PowerUp";
import AddQuestions from "./AddQuestions";
import { useNavigate } from "react-router-dom";
import profile from "../img/profile.png";
import "../App.css";
import axios from "axios";
import formatName from "../utils/formatName";

function Settings(props) {
  const location = useLocation();
  const { assessmentId } = location.state || {};
  const navigate = useNavigate();
  const [isDraft, setIsDraft] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [publishDate, setPublishDate] = useState("");
  const [deadline, setDeadline] = useState("");
  const [submissionData, setSubmissionData] = useState({
    selectedValue: "Select attempts",
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    radioValue: "D",
    numberInput: "0",
    textInput: "Minutes",
  });
  const [scoreRubricData, setScoreRubricData] = useState({
    radioValue: "A",
    checkbox1: false,
    checkbox2: false,
  });
  const [powerUpData, setPowerUpData] = useState({
    radioValue: "A",
    checkbox1: false,
    checkbox2: false,
    tags: "",
  });

  const [lastUpdate, setLastUpdate] = useState("");
  const [createdOn, setCreatedOn] = useState("");

  const formatDate = (dateString) => formatDateTime(dateString);

  useEffect(() => {
    const fetchAssessmentDates = async () => {
      if (assessmentId) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API}/getSetting?assessment_id=${assessmentId}`
          );
    
          if (response.data.success) {
            const { updated_at, created_at } = response.data.data;
    
            console.log("Assessment Dates:", response.data.data);
    
            setLastUpdate(updated_at ? formatDate(updated_at) : "Not available");
            setCreatedOn(created_at ? formatDate(created_at) : "Not available");
          } else {
            console.error(
              "Failed to fetch assessment dates:",
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error fetching assessment dates:", error);
        }
      }
    };
    
    fetchAssessmentDates();
  }, [assessmentId]);

  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.username) {
          setUserName(parsedUser.username);
        }
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }
  }, []);

  const handlePreviewClick = () => {
    if (!assessmentId) {
      console.error("Assessment ID is missing");
      return;
    }
  
    navigate("/preview", {
      state: { assessmentId }, 
    });
  };

  const handlePublishOptionsClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveDates = async () => {
    const requestData = {
      assessment_id: assessmentId || 1,
      no_of_attempts: submissionData.selectedValue,
      allow_group_submission: submissionData.checkbox1,
      time_limit: submissionData.checkbox2,
      time: submissionData.numberInput,
      time_extension: submissionData.textInput,
      view_score_immediate: submissionData.checkbox3,
      view_question_immediate: submissionData.checkbox4,
      view_correct_answers: submissionData.radioValue,
      score_value: scoreRubricData.radioValue,
      enable_grading: scoreRubricData.checkbox1,
      enable_certificate: scoreRubricData.checkbox2,
      order_of_questions: powerUpData.radioValue,
      allow_shuffle: powerUpData.checkbox1,
      mandatory_answer: powerUpData.checkbox2,
      tags: powerUpData.tags,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/insertSetting`,
        requestData
      );

      if (response.data.success) {
        alert("Settings saved successfully!");

        const tagResponse = await axios.post(
          `${process.env.REACT_APP_API}/saveTags`,
          { assessment_id: assessmentId, tags: powerUpData.tags }
        );

        if (tagResponse.data.success) {
          alert("Tags saved successfully!");
        } else {
          alert("Failed to save tags.");
        }
      } else {
        alert("Failed to save settings.");
      }
      setShowModal(false);
    } catch (error) {
      console.error("Error saving settings:", error);
      alert("An error occurred while saving settings.");
    }
    setShowModal(false);
  };

  const handlePublishedDate = async () => {
    const requestData = {
      assessment_id: assessmentId || 1,
      published_date: publishDate,
      deadline: deadline,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/insertPublishedDate`,
        requestData
      );

      if (response.data.success) {
        alert("Published Date saved successfully!");
      } else {
        alert("Failed to save settings.");
      }
      setShowModal(false);
    } catch (error) {
      console.error("Error saving settings:", error);
      alert("An error occurred while saving settings.");
    }
    setShowModal(false);
  };

  const handleToggle = async (value) => {
    setIsDraft(value);

    const status = value ? "Draft" : "Published";

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/updateAssessmentStatus`,
        {
          assessment_id: assessmentId,
          status: status,
        }
      );

      if (response.data.success) {
        alert(`Assessment status updated to ${status}`);
      } else {
        alert("Failed to update assessment status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred while updating assessment status.");
    }
  };

  const buttonStyle = {
    width: "100%",
    backgroundColor: "#A63D00",
    color: "#ffffff",
    fontFamily: "Manrope-Regular",
  };

  return (
    <div className="container">
      <AddQuestions />
      <p
        className="pt-4 text-start text-body-tertiary"
        style={{ fontFamily: "Manrope-Regular" }}
      >
        Last Update: {lastUpdate || formatDate(new Date())}
      </p>

      <div className="row" style={{ fontFamily: "Manrope-Regular" }}>
        <div className="col-sm-4">
          <Image src={profile} width="50" alt="Profile" roundedCircle />
        </div>
        <div className="col-sm-8">
          <div className="col text-start">
            <h6>{formatName(userName)}</h6>
            <p style={{ fontSize: "13px" }}>
              Created on: {createdOn || formatDate(new Date())}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div className="row mt-2 justify-content-center">
        <div className="col">
          <button
            type="button"
            className="btn w-100 rounded-pill fw-semibold preview"
            style={{
              borderColor: "#263F86",
              color: "#263F86",
              fontFamily: "Manrope-Regular",
            }}
            onClick={handlePreviewClick}
          >
            Preview
          </button>
        </div>
        <div className="col">
          <button
            type="button"
            className="btn btn-outline-success w-100 rounded-pill fw-semibold"
            style={{ fontFamily: "Manrope-Regular" }}
          >
            Export
          </button>
        </div>
      </div>

      <div
        className="btn-group w-100 mt-4"
        role="group"
        aria-label="Rounded Button Group"
      >
        <button
          type="button"
          className={`btn w-100 rounded-start ${
            isDraft ? "btn-warning" : "btn-outline-secondary"
          }`}
          style={{ fontFamily: "Manrope-Regular" }}
          onClick={() => handleToggle(true)}
        >
          Draft
        </button>
        <button
          type="button"
          className={`btn w-100 rounded-end ${
            !isDraft ? "btn-success" : "btn-outline-secondary"
          }`}
          style={{ fontFamily: "Manrope-Regular" }}
          onClick={() => handleToggle(false)}
          disabled={
            Array.isArray(powerUpData.tags) &&
            powerUpData.tags.some((tag) => tag.value === 0)
          }
        >
          Published
        </button>
      </div>

      <h6
        className="text-start mt-4 fw-semibold"
        style={{ color: "#052B81", fontFamily: "Manrope-Regular" }}
      >
        Quick Access
      </h6>

      <div className="row mt-4">
        <div className="col p-2">
          <button
            className="btn text-white rounded-circle"
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#A63D00",
            }}
          >
            <RiInformationLine size={25} />
          </button>
          <p
            className="mt-2 mx-2"
            style={{ fontSize: "12px", fontFamily: "Manrope-Regular" }}
          >
            Information
          </p>
        </div>

        <div className="col p-2">
          <button
            className="btn text-white rounded-circle"
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#A63D00",
              fontFamily: "Manrope-Regular",
            }}
          >
            <HiOutlinePaperAirplane size={25} />
          </button>
          <p
            className="mt-2 mx-2"
            style={{ fontSize: "12px", fontFamily: "Manrope-Regular" }}
          >
            Share
          </p>
        </div>

        <div className="col p-2">
          <button
            className="btn text-white rounded-circle"
            onClick={handlePublishOptionsClick}
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#A63D00",
              fontFamily: "Manrope-Regular",
            }}
          >
            <FiGlobe size={25} />
          </button>
          <p
            className="mt-2 mx-2"
            style={{ fontSize: "12px", fontFamily: "Manrope-Regular" }}
          >
            Publishing Options
          </p>
        </div>
      </div>

      <Submission onSubmissionDataChange={setSubmissionData} />
      <ScoreRubric onScoreRubricDataChange={setScoreRubricData} />
      <PowerUp onDataChange={setPowerUpData} />

      {/* <h6 className="mt-4">Submission Data:</h6>
      <pre>{JSON.stringify(submissionData, null, 2)}</pre>

      <h6 className="mt-4">Score Data:</h6>
      <pre>{JSON.stringify(scoreRubricData, null, 2)}</pre>

      <h6 className="mt-4">PowerUp Data:</h6>
      <pre>{JSON.stringify(powerUpData, null, 2)}</pre> */}

      <button
        type="button"
        className="btn mt-4"
        style={buttonStyle}
        onClick={handleSaveDates}
        disabled={
          Array.isArray(powerUpData.tags) &&
          powerUpData.tags.some((tag) => tag.value === 0)
        }
      >
        Save
      </button>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        style={{ fontFamily: "Manrope-Regular" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Publishing Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Publish On</Form.Label>
              <Form.Control
                type="datetime-local"
                value={publishDate}
                onChange={(e) => setPublishDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Deadline</Form.Label>
              <Form.Control
                type="datetime-local"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline" onClick={handleCloseModal}>
            Close
          </Button>
          <Button
            variant="outline"
            style={{ backgroundColor: "#263F86", color: "#ffffff" }}
            onClick={handlePublishedDate}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Settings;
